import {
  GROUH_MOSHTARI,
  SAVE_ALL_MOSHTARI_DATA,
  ALL_GROUH_MOSHTARI,
  SAVE_COMBO_MOSHTARI,
  ACTION_GET_MOSHTARI_RELATION,
  ACTION_GET_GROUP_MOSHTARI_RELATION,
  MOSHTARI_SEARCH,
} from "Stores/actionTypes";
import CustomerService from "Services/http/endpoints/customer/CustomerService";
import StatusHandler from "Helpers/StatusHandler";
import { read } from "Helpers/LocalStorage";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const getAllMoshtariTblData = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getAllMoshtariTblData(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const moshtariList = response.data.Value;
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const update = moshtariList.map((m, i) => {
          return {
            ...m,
            num: ((page - 1 ) * limit) + i + 1,
          };
        });
        dispatch({
          type: SAVE_ALL_MOSHTARI_DATA,
          customerData: update,
          customerDataPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getGrouhMoshtari = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getGrouhMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const moshtariList = response.data.Value;
        const update = moshtariList.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({ type: GROUH_MOSHTARI, customerGroup: update });
        return update;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getGrouhMoshtari_v2 = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getGrouhMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const update = response.data.Value.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        return update;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const InsertMoshtariData = (data) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.InsertMoshtariData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Customer_added_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteMoshtari = (data) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.deleteMoshtari(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_client_was_successfully_deleted'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationMoshtari(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationMoshtari = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getRelationMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_MOSHTARI_RELATION,
          dataRelationMoshtari: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const UpdateMoshtariData = (data) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.UpdateMoshtariData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Customer_information_successfully_edited'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getAllGorouhMoshtari = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getAllGorouhMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const moshtariList = response.data.Value;
        dispatch({
          type: ALL_GROUH_MOSHTARI,
          allGorohMoshtariData: moshtariList,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const InsertGorouhMoshtariData = (data) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.InsertGorouhMoshtariData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Customer_group_added_successfully'),
          customClass: "success"
        });
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        dispatch(getAllGorouhMoshtari(params));
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const UpdateGorouhMoshtariData = (data) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.UpdateGorouhMoshtariData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Customer_group_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteGorouhMoshtari = (data) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.deleteGorouhMoshtari(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Customer_group_deleted_successfully'),
          customClass: "success"
        });
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
        dispatch(getAllGorouhMoshtari(params));
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationGtoupMoshtari(params));
        }
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationGtoupMoshtari = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getRelationGtoupMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const { Value } = response.data;
        dispatch({
          type: ACTION_GET_GROUP_MOSHTARI_RELATION,
          dataRelationGroupMoshtari: Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getComboMoshtari = (params) => {
  return async (dispatch) => {
    try {
      const response = await CustomerService.getComboMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const moshtariList = response.data.Value;
        const update = moshtariList.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: SAVE_COMBO_MOSHTARI,
          comboMoshtari: update,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeCustomerSearch = (customerDataSearch) => (dispatch) => {
  dispatch({
    type: MOSHTARI_SEARCH,
    customerDataSearch: customerDataSearch,
  });
};
